import { render, staticRenderFns } from "./textTitle2.vue?vue&type=template&id=428d1bde&scoped=true"
import script from "./textTitle2.vue?vue&type=script&lang=js"
export * from "./textTitle2.vue?vue&type=script&lang=js"
import style0 from "./textTitle2.vue?vue&type=style&index=0&id=428d1bde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d1bde",
  null
  
)

export default component.exports